const havePermission =
  (target: string) =>
  (permissions: any): boolean =>
    Array.isArray(permissions) && permissions.includes(target);

export const isMegaAdmin = havePermission('mega_admin');
export const canWrite = havePermission('can_write');
export const isAdmin = havePermission('admin');
export const isExerciseEditor = havePermission('exercise_editor');
